import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../Api/Auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import { Base_URL, tempURl, windowURL } from "../url";
import { useAuth } from "../Context/AuthContext";
import "../Styling/Login.css";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [loginMethod, setLoginMethod] = useState("password");
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [isDivydev, setIsDivydev] = useState(false);

  useEffect(() => {
    const host = window.location.hostname;
    console.log("Current Host:", host);

    if (host.includes("divydev")) {
      setIsDivydev(true);
    }
  }, []);

  // ✅ Microsoft login (redirect to backend)
  const handleMicrosoftLogin = () => {
    window.location.href = `${tempURl}/auth/microsoft/login`;
  };

  // ✅ Google login (redirect to backend)
  const handleGoogleLogin = () => {
    window.location.href = `${tempURl}/auth/google/login`;
  };

  useEffect(() => {
    console.log(window.location.hostname);
  }, []);

  // ✅ Handle Password Login
  const handlePasswordLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(username, password);
    } catch (err) {
      const errorMessage = err.message || "Invalid username or password";
      setError(errorMessage);
      toast.error(`❌ ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  // Signup Form Component
  const SignupForm = ({ setShowSignup }) => {
    const [signupData, setSignupData] = useState({
      username: "",
      email: "",
      password: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSignup = async (e) => {
      e.preventDefault();
      setLoading(true);
      setError("");
      console.log(signupData);

      try {
        const response = await fetch(`${Base_URL}/Signup`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(signupData),
        });

        const data = await response.json();

        if (response.ok) {
          toast.success("🎉 Signup Successful! Please log in.");
          setShowSignup(false);
        } else {
          const errorMessage = data.message || "Signup failed. Try again.";
          setError(errorMessage);
          toast.error(`🦄 ${errorMessage}`);
        }
      } catch (err) {
        const errorMessage = err.message || "Something went wrong.";
        setError(errorMessage);
        toast.error(`🦄 ${errorMessage}`);
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="login-card">
        <h2 className="login-title">Sign Up</h2>
        {error && <p className="error-text">{error}</p>}
        <form onSubmit={handleSignup}>
          <div className="input-group">
            <label>Username</label>
            <input
              type="text"
              value={signupData.username}
              onChange={(e) =>
                setSignupData({ ...signupData, username: e.target.value })
              }
              required
              disabled={loading}
            />
          </div>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              value={signupData.email}
              onChange={(e) =>
                setSignupData({ ...signupData, email: e.target.value })
              }
              required
              disabled={loading}
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={signupData.password}
                onChange={(e) =>
                  setSignupData({ ...signupData, password: e.target.value })
                }
                required
                disabled={loading}
              />
              <button
                type="button"
                className="eye-button"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Signing up..." : "Sign Up"}
          </button>
        </form>
        <p className="signup-text">
          Already have an account?{" "}
          <span onClick={() => setShowSignup(false)}>Login</span>
        </p>
      </div>
    );
  };

  const ChangePasswordModal = ({ onClose }) => {
    const [formData, setFormData] = useState({
      userName: "",
      password: "",
      confirmPassword: "",
    });

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();

      try {
        setLoading(true);

        const response = await fetch(`${Base_URL}/Logins/UpdatePassword`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        const data = await response.text();

        if (response.ok) {
          toast.success("✅ Password updated successfully");
          onClose();
        } else {
          toast.error(data || "Failed to update password");
        }
      } catch (err) {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="modal-overlay">
        <div className="modal-card">
          <h3>Change Password</h3>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Username</label>
              <input
                type="text"
                value={formData.userName}
                onChange={(e) =>
                  setFormData({ ...formData, userName: e.target.value })
                }
                required
              />
            </div>

            <div className="input-group">
              <label>Current Password</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  required
                />
                <button
                  type="button"
                  className="eye-button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <div className="input-group">
              <label>New Password</label>
              <div className="password-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={formData.confirmPassword}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      confirmPassword: e.target.value,
                    })
                  }
                  required
                />
                <button
                  type="button"
                  className="eye-button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="secondary-btn"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? "Updating..." : "Update Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <div className={`login-container ${isDivydev ? "divydev-theme" : ""}`}>
      <div className="login-method-selector">
        <button
          className={`method-tab ${loginMethod === "password" ? "active" : ""}`}
          onClick={() => setLoginMethod("password")}
        >
          Sign in with Password
        </button>
        <button
          className={`method-tab ${loginMethod === "microsoft" ? "active" : ""}`}
          onClick={() => setLoginMethod("microsoft")}
        >
          Sign in with Microsoft
        </button>
        <button
          className={`method-tab ${loginMethod === "google" ? "active" : ""}`}
          onClick={() => setLoginMethod("google")}
        >
          Sign in with Google
        </button>
      </div>

      {!showSignup ? (
        <div className="login-card">
          <h2 className="login-title">
            {loginMethod === "password"
              ? "Password Login"
              : loginMethod === "microsoft"
                ? "Microsoft Login"
                : "Google Login"}
          </h2>

          {error && <p className="error-text">{error}</p>}

          {loginMethod === "password" ? (
            <form onSubmit={handlePasswordLogin}>
              <div className="input-group">
                <label>Username / Email</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="input-group">
                <label>Password</label>
                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                  <button
                    type="button"
                    className="eye-button"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? "Logging in..." : "Login with Password"}
              </button>
              <p className="forgot-password-text">
                <span onClick={() => setShowChangePassword(true)}>
                  Change Password?
                </span>
              </p>
            </form>
          ) : loginMethod === "microsoft" ? (
            <div className="microsoft-login-section">
              <p className="microsoft-description">
                Sign in using your Microsoft account
              </p>
              <button
                onClick={handleMicrosoftLogin}
                className="microsoft-login-button"
                disabled={loading}
              >
                <img
                  src="https://docs.microsoft.com/en-us/azure/active-directory/develop/media/howto-add-branding-in-azure-ad-apps/ms-symbollockup_signin_light.png"
                  alt="Microsoft"
                  className="microsoft-logo"
                />
                {loading ? "Signing in..." : "Sign in with Microsoft"}
              </button>
              <p className="microsoft-note">
                Note: Your Microsoft email must be registered in our system
              </p>
            </div>
          ) : (
            // Google Login Section
            <div className="microsoft-login-section">
              <p className="microsoft-description">
                Sign in using your Google account
              </p>
              <button
                onClick={handleGoogleLogin}
                className="google-login-button"
                disabled={loading}
                style={{
                  padding: "10px",
                  fontSize: "14px",
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  marginBottom: "10px",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  className="google-logo"
                >
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                {loading ? "Signing in..." : "Sign in with Google"}
              </button>
              <p className="microsoft-note">
                Note: Your Gmail address must be registered in our system
              </p>
            </div>
          )}

          <p className="signup-text">
            Don't have an account?{" "}
            <span onClick={() => setShowSignup(true)}>Sign up</span>
          </p>
        </div>
      ) : (
        <SignupForm setShowSignup={setShowSignup} />
      )}
      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </div>
  );
};

export default Login;

// import { useState,useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { loginUser } from "../Api/Auth";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { Base_URL, tempURl, windowURL } from "../url";
// import { useAuth } from "../Context/AuthContext";
// import "../Styling/Login.css";

// const Login = () => {
//   const { login } = useAuth();
//   const navigate = useNavigate();

//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showSignup, setShowSignup] = useState(false);
//   const [loginMethod, setLoginMethod] = useState("password");
//   const [showChangePassword, setShowChangePassword] = useState(false);
// const [isDivydev, setIsDivydev] = useState(false);

// useEffect(() => {
//   const host = window.location.hostname;
//   console.log("Current Host:", host);

//   if (host.includes("divydev")) {
//     setIsDivydev(true);
//   }
// }, []);

//   //   console.log(login, 'login');
//   // ✅ Start Microsoft login (redirect to backend)
//   const handleMicrosoftLogin = () => {
//     //  window.location.href = ('${windowURL}');
//     //   window.location.href = "https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net/auth/Login";
//     window.location.href = `${tempURl}/auth/microsoft/login`;
//   };
//   useEffect(() => {
//   console.log(window.location.hostname);
// }, []);

//   // ✅ Handle Password Login
//   const handlePasswordLogin = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     try {
//       login(username, password);
//     } catch (err) {
//       const errorMessage = err.message || "Invalid username or password";
//       setError(errorMessage);
//       toast.error(`❌ ${errorMessage}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Signup Form Component
//   const SignupForm = ({ setShowSignup }) => {
//     const [signupData, setSignupData] = useState({
//       username: "",
//       email: "",
//       password: "",
//     });
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState("");
//     const [showPassword, setShowPassword] = useState(false);

//     const handleSignup = async (e) => {
//       e.preventDefault();
//       setLoading(true);
//       setError("");
//       console.log(signupData);

//       try {
//         const response = await fetch(`${Base_URL}/Signup`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(signupData),
//         });

//         const data = await response.json();

//         if (response.ok) {
//           toast.success("🎉 Signup Successful! Please log in.");
//           setShowSignup(false);
//         } else {
//           const errorMessage = data.message || "Signup failed. Try again.";
//           setError(errorMessage);
//           toast.error(`🦄 ${errorMessage}`);
//         }
//       } catch (err) {
//         const errorMessage = err.message || "Something went wrong.";
//         setError(errorMessage);
//         toast.error(`🦄 ${errorMessage}`);
//       } finally {
//         setLoading(false);
//       }
//     };

//     return (
//       <div className="login-card">
//         <h2 className="login-title">Sign Up</h2>
//         {error && <p className="error-text">{error}</p>}
//         <form onSubmit={handleSignup}>
//           <div className="input-group">
//             <label>Username</label>
//             <input
//               type="text"
//               value={signupData.username}
//               onChange={(e) =>
//                 setSignupData({ ...signupData, username: e.target.value })
//               }
//               required
//               disabled={loading}
//             />
//           </div>
//           <div className="input-group">
//             <label>Email</label>
//             <input
//               type="email"
//               value={signupData.email}
//               onChange={(e) =>
//                 setSignupData({ ...signupData, email: e.target.value })
//               }
//               required
//               disabled={loading}
//             />
//           </div>
//           <div className="input-group">
//             <label>Password</label>
//             <div className="password-wrapper">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 value={signupData.password}
//                 onChange={(e) =>
//                   setSignupData({ ...signupData, password: e.target.value })
//                 }
//                 required
//                 disabled={loading}
//               />
//               <button
//                 type="button"
//                 className="eye-button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 disabled={loading}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </button>
//             </div>
//           </div>
//           <button type="submit" className="login-button" disabled={loading}>
//             {loading ? "Signing up..." : "Sign Up"}
//           </button>
//         </form>
//         <p className="signup-text">
//           Already have an account?{" "}
//           <span onClick={() => setShowSignup(false)}>Login</span>
//         </p>
//       </div>
//     );
//   };
//   const ChangePasswordModal = ({ onClose }) => {
//   const [formData, setFormData] = useState({
//     userName: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // if (formData.password !== formData.confirmPassword) {
//     //   toast.error("Passwords do not match");
//     //   return;
//     // }

//     try {
//       setLoading(true);

//       const response = await fetch(`${Base_URL}/Logins/UpdatePassword`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.text();

//       if (response.ok) {
//         toast.success("✅ Password updated successfully");
//         onClose();
//       } else {
//         toast.error(data || "Failed to update password");
//       }
//     } catch (err) {
//       toast.error("Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="modal-overlay">
//       <div className="modal-card">
//         <h3>Change Password</h3>

//         <form onSubmit={handleSubmit}>
//           <div className="input-group">
//             <label>Username</label>
//             <input
//               type="text"
//               value={formData.userName}
//               onChange={(e) =>
//                 setFormData({ ...formData, userName: e.target.value })
//               }
//               required
//             />
//           </div>

//           <div className="input-group">
//             <label>Current Password</label>
//             <div className="password-wrapper">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 value={formData.password}
//                 onChange={(e) =>
//                   setFormData({ ...formData, password: e.target.value })
//                 }
//                 required
//               />
//               <button
//                 type="button"
//                 className="eye-button"
//                 onClick={() => setShowPassword(!showPassword)}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </button>
//             </div>
//           </div>

//           <div className="input-group">
//             <label>New Password</label>
//             <div className="password-wrapper">
//               <input
//                 type={showConfirmPassword ? "text" : "password"}
//                 value={formData.confirmPassword}
//                 onChange={(e) =>
//                   setFormData({
//                     ...formData,
//                     confirmPassword: e.target.value,
//                   })
//                 }
//                 required
//               />
//               <button
//                 type="button"
//                 className="eye-button"
//                 onClick={() =>
//                   setShowConfirmPassword(!showConfirmPassword)
//                 }
//               >
//                 {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//               </button>
//             </div>
//           </div>

//           <div className="modal-actions">
//             <button
//               type="button"
//               className="secondary-btn"
//               onClick={onClose}
//               disabled={loading}
//             >
//               Cancel
//             </button>
//             <button type="submit" className="login-button" disabled={loading}>
//               {loading ? "Updating..." : "Update Password"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

//   return (
//     <div className={`login-container ${isDivydev ? "divydev-theme" : ""}`}>

//       <div className="login-method-selector">
//         <button
//           className={`method-tab ${loginMethod === "password" ? "active" : ""}`}
//           onClick={() => setLoginMethod("password")}
//         >
//           Sign in with Password
//         </button>
//         <button
//           className={`method-tab ${
//             loginMethod === "microsoft" ? "active" : ""
//           }`}
//           onClick={() => setLoginMethod("microsoft")}
//         >
//           Sign in with Microsoft
//         </button>
//       </div>

//       {!showSignup ? (
//         <div className="login-card">
//           <h2 className="login-title">
//             {loginMethod === "password" ? "Password Login" : "Microsoft Login"}
//           </h2>

//           {error && <p className="error-text">{error}</p>}

//           {loginMethod === "password" ? (
//             <form onSubmit={handlePasswordLogin}>
//               <div className="input-group">
//                 <label>Username</label>
//                 <input
//                   type="text"
//                   value={username}
//                   onChange={(e) => setUsername(e.target.value)}
//                   required
//                   disabled={loading}
//                 />
//               </div>
//               <div className="input-group">
//                 <label>Password</label>
//                 <div className="password-wrapper">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                     disabled={loading}
//                   />
//                   <button
//                     type="button"
//                     className="eye-button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     disabled={loading}
//                   >
//                     {showPassword ? <FaEyeSlash /> : <FaEye />}
//                   </button>
//                 </div>
//               </div>
//               <button type="submit" className="login-button" disabled={loading}>
//                 {loading ? "Logging in..." : "Login with Password"}
//               </button>
//               <p className="forgot-password-text">
//   <span onClick={() => setShowChangePassword(true)}>
//     Change Password?
//   </span>
// </p>

//             </form>
//           ) : (
//             <div className="microsoft-login-section">
//               <p className="microsoft-description">
//                 Sign in using your Microsoft account
//               </p>
//               <button
//                 onClick={handleMicrosoftLogin}
//                 className="microsoft-login-button"
//                 disabled={loading}
//               >
//                 <img
//                   src="https://docs.microsoft.com/en-us/azure/active-directory/develop/media/howto-add-branding-in-azure-ad-apps/ms-symbollockup_signin_light.png"
//                   alt="Microsoft"
//                   className="microsoft-logo"
//                 />
//                 {loading ? "Signing in..." : "Sign in with Microsoft"}
//               </button>
//               <p className="microsoft-note">
//                 Note: Your Microsoft email must be registered in our system
//               </p>
//             </div>
//           )}

//           <p className="signup-text">
//             Don't have an account?{" "}
//             <span onClick={() => setShowSignup(true)}>Sign up</span>
//           </p>
//         </div>
//       ) : (
//         <SignupForm setShowSignup={setShowSignup} />
//       )}
//       {showChangePassword && (
//   <ChangePasswordModal
//     onClose={() => setShowChangePassword(false)}
//   />
// )}

//     </div>
//   );
// };

// export default Login;
